import { get } from '@/config/fetchApi.js'
import * as constants from '@/config/constants.js'

export const getLastUpdated = () => get(constants.LAST_UPDATE)
